import React from "react";
import {Form, Tabs, Container, Tab,Row,Col,Nav} from "react-bootstrap";
import PersonalHistory from "./personalHistory";
import FamilyHistory from "./familyHistory";
import MedicalHistory from "./medicalHistory";
import CurrentTreatment from "./currentTreatment";
import './demographics.css'
class Demographics extends React.Component{

    
    

    render() {
        return(
            <div>
             <Tab.Container defaultActiveKey={'personal'}>
                 <Row>
                     <Col sm={2}>
                         <div className={'col-menu'}>
                         <br/>
                         <h5>Categories</h5><br/>
                         <Nav variant={"pills"}>
                         <Nav.Item>
                             <Nav.Link eventKey={'personal'}>Personal information</Nav.Link>
                         </Nav.Item>
                         </Nav>
                         <Nav variant={'pills'}>
                         <Nav.Item>
                             <Nav.Link eventKey={'family'}>Family History</Nav.Link>
                         </Nav.Item>
                         </Nav>
                         <Nav variant={'pills'}>
                         <Nav.Item>
                             <Nav.Link eventKey={'medical_history'}>Medical History</Nav.Link>
                         </Nav.Item>
                         
                         </Nav>
                         <Nav variant={'pills'}>
                         
                         </Nav>
                         </div>

                     </Col>

                     <Col sm={9}>
                         <Tab.Content>
                             <Tab.Pane eventKey={'personal'}>
                                 <br/>
                                 <PersonalHistory handler={this.props.handler} handleGender={this.props.handleGender}  disabled={this.props.disabled }data={this.props.data!=null? this.props.data["personal_info"]:null}patientID={this.props.patientID}/>

                             </Tab.Pane>
                             <Tab.Pane eventKey={'family'}>
                                <br/>
                                <FamilyHistory data={this.props.data!=null? this.props.data["family_history"]:null} disabled={this.props.disabled } handler={this.props.handler}/>
                             </Tab.Pane>
                                <br/>
                             <Tab.Pane eventKey={'medical_history'}>
                                <MedicalHistory data={this.props.data!=null? this.props.data["medical_history"]:null}  disabled={this.props.disabled } handler={this.props.handler}/>
                             </Tab.Pane>
                             
                             
                         </Tab.Content>
                     </Col>

                     </Row>

             </Tab.Container>
            </div>
        )
    }
}
Demographics.defaultProps = {
    data:null,
    disabled:false,
}
export  default Demographics;